module.exports = __webpack_public_path__ + "../../img/parallax12.5928c9d1.jpg";